import React from "react";
import Sidebar from "../../Navigation/Sidebar/Sidebar";
import { Button, Box, TextField, IconButton } from "@mui/material";
import leftArrow from "../../../assests/leftArrow.svg";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
export const CouponAplicableItemComponent = ({
  couponCreationStep12,
  handleMvIdBtnClick,
  handleChangeMvIds,
  handleChangeSlotIds,
  handleChangeMealTypesIds,
  newMealTypeIds,
  newMvId,
  newSlotId,
  mvIds,
  slotIds,
  mealTypeIds,
  handleAddMeal,
  handleAddMvId,
  handleAddSlot,
  activeMvIdBtn,
  showMvIdInput,
  handleMealIdBtnClick,
  activeMealIdBtn,
  showMealIdInput,
  handleSlotIdBtnClick,
  activeSlotIdBtn,
  showSlotIdInput,
  slotError,
  mvError,
  mealError,
  handleRemove
  
}) => {
  const navigate = useNavigate();
  const handleClick = () => navigate("/");
  const goback = () => navigate(-1);

  return (
    <div style={{ display: "flex", height: "100vh", overflow: "hidden" }}>
      <Sidebar />
      <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        <div style={{ padding: "20px 40px 100px", overflowY: "auto" }}>
          <div style={{ marginBottom: "20px" }}>
            <h2>
              <img
                onClick={handleClick}
                style={{ width: "22px", cursor: "pointer", marginRight: "10px" }}
                src={leftArrow}
                alt=""
              />
              Create Coupon
            </h2>
          </div>

          <div style={{ display: "flex", gap: "40px" }}>
            {/* Left Column - Input Section */}
            <div style={{ flex: 1, overflowY: "auto", maxHeight: "calc(100vh - 180px)" }}>
              {[
                {
                  label: "Is it only applicable on certain Slots?",
                  active: activeSlotIdBtn,
                  onClick: handleSlotIdBtnClick,
                  showInput: showSlotIdInput,
                  inputValue: newSlotId,
                  onChange: handleChangeSlotIds,
                  onAdd: handleAddSlot,
                  error: slotError,
                  inputLabel: "Enter Slot ID",
                },
                {
                  label: "2. Is it only applicable on certain Products?",
                  active: activeMvIdBtn,
                  onClick: handleMvIdBtnClick,
                  showInput: showMvIdInput,
                  inputValue: newMvId,
                  onChange: handleChangeMvIds,
                  onAdd: handleAddMvId,
                  error: mvError,
                  inputLabel: "Enter Product ID",
                },
                {
                  label: "3. Is it only applicable on certain Meal type?",
                  active: activeMealIdBtn,
                  onClick: handleMealIdBtnClick,
                  showInput: showMealIdInput,
                  inputValue: newMealTypeIds,
                  onChange: handleChangeMealTypesIds,
                  onAdd: handleAddMeal,
                  error: mealError,
                  inputLabel: "Enter Meal Type ID",
                },
              ].map((section, idx) => (
                <Box
                  key={idx}
                  sx={{
                    maxWidth: "100%",
                    mb: 4,
                    p: 3,
                    border: "1px solid #e0e0e0",
                    borderRadius: "12px",
                    backgroundColor: "#fafafa",
                  }}
                >
                  <label style={{ display: "block", fontWeight: 600, marginBottom: 10 }}>
                    {section.label}
                  </label>

                  <div style={{ display: "flex", gap: "12px", marginBottom: "16px" }}>
                    {["Yes", "No"].map((opt) => (
                      <button
                        key={opt}
                        onClick={() => section.onClick(opt)}
                        style={{
                          padding: "8px 16px",
                          borderRadius: "6px",
                          border:
                            section.active === opt
                              ? "2px solid #1976d2"
                              : "1px solid #ccc",
                          backgroundColor:
                            section.active === opt ? "#e3f2fd" : "#f9f9f9",
                          cursor: "pointer",
                        }}
                      >
                        {opt}
                      </button>
                    ))}
                  </div>

                  {section.showInput && (
                    <>
                      <TextField
                        fullWidth
                        type="number"
                        size="small"
                          error={!!section.error}
  helperText={section.error}
                        label={section.inputLabel}
                        value={section.inputValue}
                        onChange={section.onChange}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            section.onAdd();
                          }
                        }}
                      
                        sx={{ mb: 1 }}
                      />
                      <div style={{ textAlign: "right" }}>
                        <button
                          onClick={section.onAdd}
                          style={{
                            background: "none",
                            border: "none",
                            color: "#1976d2",
                            cursor: "pointer",
                          }}
                        >
                          + add
                        </button>
                      </div>
                    </>
                  )}
                </Box>
              ))}
            </div>

         <Box sx={{ minWidth: 300, maxWidth: 400, overflowY: "auto", maxHeight: "calc(100vh - 180px)" }}>
              <h4>Added IDs</h4>
              {[
                ["Slot IDs", slotIds, "slot"],
                ["MV IDs", mvIds, "mv"],
                ["Meal Type IDs", mealTypeIds, "meal"],
              ].map(([label, ids, type], i) => (
                <div key={i} style={{ marginBottom: "16px" }}>
                  <strong>{label}:</strong>
                  <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginTop: "8px" }}>
                    {ids.length > 0 ? (
                      ids.map((id, index) => (
                        <div
                          key={index}
                          style={{
                            background: "#e3f2fd",
                            padding: "6px 10px",
                            borderRadius: "6px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          {id}
                          <IconButton
                            size="small"
                            onClick={() => handleRemove(type, index)}
                            sx={{ ml: 1 }}
                          >
                            <CloseIcon fontSize="small" />
                          </IconButton>
                        </div>
                      ))
                    ) : (
                      <div style={{ color: "#999" }}>Not added</div>
                    )}
                  </div>
                </div>
              ))}
            </Box>
          </div>
        </div>

        {/* Footer Buttons */}
        <Box
          sx={{
            position: "fixed",
            bottom: 0,
            left: "250px",
            width: "calc(100% - 250px)",
            background: "#fff",
            borderTop: "1px solid #e0e0e0",
            padding: "16px 40px",
            display: "flex",
            justifyContent: "center",
            zIndex: 1000,
          }}
        >
          <Button variant="outlined" onClick={goback} sx={{ mr: 2 }}>
            Cancel
          </Button>
  
          <Button
            variant="contained"
           onClick={couponCreationStep12}
            sx={{
              borderRadius: 2,
              textTransform: "none",
              width: 120,
              height: 40,
              background:"rgba(0, 177, 119, 1)",
            }}
          >
            NEXT
          </Button>
        </Box>
      </div>
    </div>
  );
};
